import {React, useState, useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css'; // استایل‌های پیش‌فرض Swiper
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Row, Col } from "react-bootstrap";
import UseMediaQuery from "./UseMediaQuery";
import {Api} from "./api";
import {Placeholder} from 'react-bootstrap';


/*import slider1 from '../img/slider/slider1.jpg';
import slider2 from '../img/slider/slider2.jpg';
import slider3 from '../img/slider/slider3.jpg';
import slider4 from '../img/slider/slider4.jpg';
import slider5 from '../img/slider/slider5.jpg';
import slider6 from '../img/slider/slider6.jpeg';
import slider7 from '../img/slider/slider7.jpeg';
import slider8 from '../img/slider/slider8.jpeg';*/

/*import slidermobile1 from '../img/slider/slider-mobile1.jpg';
import slidermobile2 from '../img/slider/slider-mobile2.jpg';
import slidermobile3 from '../img/slider/slider-mobile3.jpg';
import slidermobile4 from '../img/slider/slider-mobile4.jpg';
import slidermobile5 from '../img/slider/slider-mobile5.jpg';
/*import slidermobile6 from '../img/slider/slider-mobile6.jpeg';
import slidermobile7 from '../img/slider/slider-mobile7.jpeg';
import slidermobile8 from '../img/slider/slider-mobile8.jpeg';*/

//const desktopImages = [slider1, slider2, slider3, slider4,slider5];
//const mobileImages = [slidermobile1, slidermobile2, slidermobile3, slidermobile4,slidermobile5];

const Slider = () => {
    const [slides, setSlides] = useState([]);
    const fetchslides = async () => {
        try {
            const response = await Api("slider");
            if(response && response.success==true){
               
               setSlides(response.psdata.papaslider.slides);
                //setOnlineGoldPrice(response.psdata.gold_price); 
                //localStorage.setItem("goldprice", response.psdata.goldprice); 
            }
        } catch (error) {
            console.error("Error fetching price data:", error);
        }
    }

    useEffect(() => {
        fetchslides();
    }, []);

    const isMobile = UseMediaQuery("(max-width: 768px)");

    return (
        <>
            {slides.length === 0?
            ( 
            <div className="banner-i p-4">
               <div className="banner-i" >
                    <Placeholder as="div" animation="glow" style={isMobile ? { width: '768', height: '305px' }: { width: '3309px', height: '600px' }}>
                        <Placeholder style={{ width: '100%' , height: '100%'}}/>
                    </Placeholder>
                </div>
            </div>
            ):(
            <Swiper
                modules={[Autoplay]}
                slidesPerView={1}
                //pagination={{ clickable: true }}
                loop
                speed={3000}
                autoplay={{
                    delay: 6000, // زمان بین هر اسلاید به میلی‌ثانیه
                    disableOnInteraction: false, // اگر کاربر با اسلایدر تعامل داشت، ادامه بده
                }}
            >   
            {slides.map((slideImage, index) => {             
                    const currentImage = isMobile ? slideImage.mobile_image_url : slideImage.image_url;
                    // برای اسلاید اول، محتوای خاص داریم
                    return (
                        <SwiperSlide key={index}>
                            <div className="banner-i" style={{ backgroundImage: `url(${currentImage})` }}>
                               
                                <Row className="justify-content-center text-center mt-4">
                                    <Col>
                                    <br/>
                                        <h1 className="title-banner">{slideImage.legend}</h1>
                                        <p className="drc-banner">{slideImage.description}</p>
                                    </Col>
                                </Row>
                                
                            </div>
                        </SwiperSlide>
                    );
                })
                }
            </Swiper>
            )}
        </>
    );
};

export default Slider;